import { Box, Center, Spinner, useMediaQuery } from '@podiumhq/design-system';

import { useSelectPlanCheckoutContext } from 'contexts/SelectPlanCheckoutContextProvider';
import { FadeAnimationWrapper } from 'styles';

import { FakeWrapper } from '../../layout';

import BuyNowWithDiscountContent from './BuyNowWithDiscountContent';

const BuyNowWithDiscount = () => {
  const { dataLoading } = useSelectPlanCheckoutContext();
  const [isSmallerThan850px] = useMediaQuery(`(max-width: 850px)`);

  return (
    <FakeWrapper
      marginTop={-55}
      modalWidth="640px"
      showIcon={true}
      title="Skip the trial, save money."
    >
      <Box position="relative">
        <FadeAnimationWrapper fadeOut startTransition={!dataLoading}>
          <Center height="100%" position="absolute" width="100%">
            <Spinner padding="24px" size="md" />
          </Center>
        </FadeAnimationWrapper>

        <FadeAnimationWrapper
          fadeIn
          startTransition={!dataLoading}
          transitionDelay="150ms"
        >
          <BuyNowWithDiscountContent isMobile={isSmallerThan850px} />
        </FadeAnimationWrapper>
      </Box>
    </FakeWrapper>
  );
};

export default BuyNowWithDiscount;
